module.exports = __webpack_public_path__ + "static/media/040-down.ac9b56a1.svg";